/* Sidepanelet på smal skjerm. På bred skjerm står lenkene i headeren, og
 * knappen er skjult. Selve visningen ligger i CSS; her settes bare tilstanden.
 *
 * Tilgjengelighet: Esc og et klikk på bakteppet lukker, fokus flyttes inn i
 * panelet når det åpnes og tilbake til knappen når det lukkes, tabbing holdes
 * inne i panelet så lenge det er åpent, og resten av siden settes inert. */

import { $, $$ } from './verktoy.js';

const bredSkjerm = matchMedia('(min-width: 1025px)');

export function startMeny({ stoppRulling, startRulling, visHeader }) {
  const knapp = $('#hamburger');
  const meny = $('#meny');
  const utenfor = [$('.topplinje'), $('main'), $('footer')].filter(Boolean);
  let apen = false;

  function sett(vis, { fokus = true } = {}) {
    apen = vis;
    document.body.classList.toggle('meny-apen', vis);
    knapp.setAttribute('aria-expanded', String(vis));
    meny.setAttribute('aria-hidden', String(!vis));
    for (const el of utenfor) el.inert = vis;

    if (vis) {
      visHeader();
      stoppRulling();
    } else {
      startRulling();
    }

    if (!fokus) return;
    if (vis) {
      // Panelet står fortsatt utenfor skjermen når fokus settes. Uten
      // preventScroll ruller nettleseren det inn i tillegg til at det glir inn.
      fokuserbare()[0]?.focus({ preventScroll: true });
    } else {
      knapp.focus();
    }
  }

  const fokuserbare = () => $$('a[href], button', meny).filter(el => el.offsetParent !== null);

  knapp.addEventListener('click', () => sett(true));
  for (const el of $$('[data-lukk-meny]', meny)) el.addEventListener('click', () => sett(false));

  /* Blir vinduet bredt mens panelet er åpent, forsvinner både panelet og
     knappen. Da må siden låses opp igjen. */
  bredSkjerm.addEventListener('change', () => {
    if (apen && bredSkjerm.matches) sett(false, { fokus: false });
  });

  addEventListener('keydown', e => {
    if (!apen) return;
    if (e.key === 'Escape') {
      sett(false);
      return;
    }
    if (e.key !== 'Tab') return;

    // Hold tabbingen inne i panelet.
    const felt = fokuserbare();
    const forste = felt[0];
    const siste = felt[felt.length - 1];
    if (e.shiftKey && document.activeElement === forste) {
      e.preventDefault();
      siste.focus();
    } else if (!e.shiftKey && document.activeElement === siste) {
      e.preventDefault();
      forste.focus();
    }
  });

  return { erApen: () => apen, lukk: () => apen && sett(false) };
}
